import React, { Component } from "react";
import PreLoaderWidget from '../../components/Loader';
import { getLoggedInUser, hasPermission } from "../../helpers/authUtils";
import DropDownDoenca from '../../components/DropDownDoencas';
import {
  getConversations,
  getRef, saveMessage,
  updateConversa,
  updateMessage,
} from '../../Libs/Chat';

import {
  getPaciente,
  updatePaciente,
  getListHistorico,
  getListMidia,
  getListAtestado,
  getListReceita,
  getListReceituario,
  getSolicitacaoExames,
  getListRiscoCirurgico,
  getMensagens,
  getAuditorias
} from "../../Libs/paciente";
import ListStatus from "../../components/ListStatus";

import { getListCirurgia } from "../../Libs/cirurgia";
import Notificacao from "../../components/Notificacao";
import { Link } from "react-router-dom";
import moment from "moment";
import ModalComponent from "../../components/Modal";
import { connect } from "react-redux";
import {
  firebaseAuth,
  firebaseFire as Libfirebase,
  firebaseStorage
} from "../../helpers/firebase-config";
import Exame from "../../components/Exame";
import RiscoCirurgico from "../../components/RiscoCirurgico";
import Input from "../../components/Input";
import Viewer from 'react-viewer';
import 'tui-image-editor/dist/tui-image-editor.css'
import ImageEditor from '@toast-ui/react-image-editor'
import DadosPaciente from "../../components/Paciente";

import Queixa from '../../Views/Paciente/CadastrarHistorico';
import CadastroReceita from '../../Views/Paciente/CadastrarReceita';
import CadastrarReceituario from '../../Views/Paciente/CadastrarReceituario';
import CadastrarAtestado from '../../Views/Paciente/CadastrarAtestado';
import CadastrarCirurgia from '../../Views/Cirurgia/cadastro'
import CadastrarExame from '../../Views/Paciente/CadastrarSolicitacaoExames'
import CadastrarAnexo from '../../Views/Paciente/CadastrarAnexo'

import './historico.scss';

import axios from 'axios';
import { confirmAlert } from "react-confirm-alert";

import ContAnamnese from './ContAnamnese';
import ContReceita from "./ContReceita";
import ContReceituario from "./ContReceituario";
import ContAtestado from "./ContAtestado";
import ContCirurgia from "./ContCirurgia";
import ContExames from "./ContExames";
import ContAnexo from "./ContAnexo";
import ContMensagem from "./ContMensagem";

import GbDropdown from "../../gb-components/GbDropdown";
import { finalizarAtendimentoPaciente, iniciarConsultaPaciente } from "../../Libs/Agenda";
import { PermissaoGeral } from "../../helpers/enums";
import { ToastContainer, toast } from "react-toastify";
import RightSidebar from "../../components/RightSidebar";
import { sendWhatsappMessage, sleep } from "../../helpers/utils";
import { setInitCall } from "../../redux/default/actions";
import ContAuditoria from "./Auditoria";
import CadastrarAuditoria from "./CadastrarAuditoria";
import VideoCallComponent from "../../components/VideoCallComponent/VideoCallComponent";

// const instanceAPI = "https://api.z-api.io/instances/394207B128E900BFC7029A907D5E67B3/token/E1AF9F3796B5131FD8947C94/";

// const sendMessageWhats = async (phone, message) => {
//   try {
//     await axios.post(instanceAPI + "send-text", { phone, message });
//   }
//   catch (e) {
//     console.log("error on send msg", e);
//   }
// };


class Paciente extends Component {
  constructor(props) {
    super(props);

    this.state = {
      idPaciente: "",
      idHistorico: "",
      card: "historico",
      historico: [],
      filenames: [],
      downloadURLs: [],
      isUploading: false,
      uploadProgress: 0,
      msg: "",
      notifition: false,
      nameclass: "",
      paciente: null,
      openModal: false,
      openModalRetorno: false,
      dataRetorno: "",
      nomearquivo: "",
      openModalCirurgia: false,
      openModalReceita: false,
      openModalReceituario: false,
      openModalRiscoCirurgico: false,
      openAlteraStatusModal: false,
      itemExame: null,
      usuario: getLoggedInUser(),
      new: false,
      aba: "",
      visible: false,
      linhaDoTempo: [],
      anexos: [],
      anexosPdf: [],
      idComent: null,
      carregando: false,
      txtComent: ' ',
      block: true,
      showImg: false,
      images: [],
      editImage: false,
      editImageSrc: '',
      cirurgia: null,
      profissionais: [],
      showImgIndex: 0,
      fixedMenu: false,
      top: '0px',
      solicitacaoExames: [],
      preloadMensagens: false,
      mensagens: [],
      preloadReceita: false, preloadReceituario: false, preloadAtestado: false, preloadCirurgia: false, preloadSolicExame: false, preloadAnexos: false, preloadAuditoria: false,
      wpp: null,
      isOnModal: false,
      openMDLCAD: false,
      modalOBJ: '',
      confirmaResponsavel: false,
      responsavel: null,
      proprioResponsavel: false,
      interacao: false,
      atendimentoId: null,
      buscandoAtendimento: true,
      atendimentoObj: null,
      loadingHist: false,
      menu: [
        { card: 'historico', descricao: 'Anamnese e Evoluções' },
        { card: 'receita', descricao: 'Receita' },
        { card: 'receituario', descricao: 'Receituário' },
        { card: 'atestado', descricao: 'Atestado' },
        { card: 'cirurgia', descricao: 'Cirurgia' },
        { card: 'exames', descricao: 'Solicitação Exames' },
        { card: 'anexos', descricao: 'Anexos' },
        { card: 'mensagens', descricao: 'Mensagens' },
        { card: 'auditoria', descricao: 'Auditoria Material' }
      ],
      menu2: ['Anamnese e Evoluções', 'Receita', 'Receituário', 'Atestado', 'Cirurgia', 'Solicitação Exames', 'Anexos', 'Mensagens', 'Auditoria Material'],
      stopmenu: false,
      CID: null,
      CID2: null,
      openModalCID: false,
      iniAtendModal: false,
      recebendoLigacao: false,
      recebendoLigacaoObj: null,
      recebendoLigacaoObjID: null,
      ligacaoObj: null
    };

    this.divMenu = React.createRef();
    this.divConteudo = React.createRef();
    this.inputMessage = React.createRef();

    this._setResponder = this._setResponder.bind(this);
    this._setComentario = this._setComentario.bind(this);
    this.openImageAnexo = this.openImageAnexo.bind(this);
    this.editImageAnexo = this.editImageAnexo.bind(this);
    this.setAnexo = this.setAnexo.bind(this);
    this.handleUploadSuccess = this.handleUploadSuccess.bind(this);
    this.selectMenu = this.selectMenu.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.carregar = this.carregar.bind(this);
    this.finishCall = this.finishCall.bind(this);
    this.getAuditoriasData = this.getAuditoriasData.bind(this);
  }



  async componentDidMount() {
    // console.log('agenda', this.props.agenda);
    await this.carregar();
    /* document.body.classList.add('noOverflow'); */
    // this.setState({ mapWidth: this.container.offsetWidth });
  }

  verificarAtendimento = async () => {
    const usuario = getLoggedInUser();

    if (this.state.paciente) {
      this.setState({
        buscandoAtendimento: true
      });
      const semAtendimento = () => {
        this.setState({
          interacao: false,
          atendimentoId: null,
          buscandoAtendimento: false,
          atendimentoObj: null,
          iniAtendModal: [PermissaoGeral.Administrador, PermissaoGeral.Médico].includes(usuario.permissao)
        });
      }
      const refProf = this.state.profissionais.find(x => x.CPF === getLoggedInUser().cpf);
      if (refProf) {
        await Libfirebase.collection('atendimento')
          .where('paciente', '==', this.state.idPaciente)
          .where('medico', '==', refProf.ref)
          .where('situacao', '==', 'ativo')
          .get().then(res => {
            if (res.docs.length > 0) {
              console.log('=================================', res.docs[0].data())
              this.setState({
                interacao: true,
                atendimentoId: res.docs[0].id,
                buscandoAtendimento: false,
                atendimentoObj: { id: res.docs[0].id, ref: res.docs[0].ref, obj: res.docs[0], ...res.docs[0].data() },
                status: res.docs[0].data().status, // na verdade tem que pegar o status do atendimento e não da coleção de paciente
                CID: res.docs[0].data().CID,
                CID2: res.docs[0].data().CID,
              });
            } else {
              semAtendimento();
            }
          }).catch(() => {
            semAtendimento();
          })
      } else {
        semAtendimento();
      }
    }
  }

  iniciarAtendimento = async () => {
    if (this.state.paciente) {
      this.setState({
        buscandoAtendimento: true
      });

      const refProf = this.state.profissionais.find(x => x.CPF === getLoggedInUser().cpf);
      if (refProf) {
        await Libfirebase.collection('atendimento').add({
          paciente: this.state.idPaciente,
          medico: refProf.ref,
          situacao: 'ativo',
          data: moment().format('YYYY-MM-DD HH:mm:ss')
        });
        this.verificarAtendimento();
        if (this.props.agenda) {
          iniciarConsultaPaciente(this.props.agenda.agenda, this.props.agenda.paciente, this.props.agenda.ref);
        }
      }
    }
  }

  finalizarAtendimento = async () => {
    this.setState({
      openAlteraStatusModal: true
    });
  }

  adicionaDoenca = v => {
    console.log(v);
    if (this.state.doencas.filter(x => x.codigo === v.codigo).length > 0) {
      alert("Doença já adicionada anteriormente!");
      return;
    }
    let doencas = this.state.doencas;
    doencas.push(v.value);
    this.setState({ doencas });
  }
  removerDoenca = v => {
    let doencas = this.state.doencas.filter(x => x.codigo !== v.codigo);
    this.setState({ doencas });
  }


  tornarResponsavel = async () => {
    if (this.state.paciente) {
      const refProf = this.state.profissionais.find(x => x.CPF === getLoggedInUser().cpf);
      if (refProf) {
        confirmAlert({
          title: 'Confirmar responsabilidade!',
          message: 'Você tem certeza que deseja responsável pelo atendimento deste paciente?',
          buttons: [
            {
              label: 'Sim!',
              onClick: () => {
                this.state.paciente.ref.update({
                  responsavel: refProf.ref
                });
                this.setState({
                  confirmaResponsavel: false,
                  notifition: true,
                  msg: "Você agora é responsável pelo paciente!",
                  nameclass: 'alert-primary',
                  responsavel: refProf,
                  proprioResponsavel: true,
                })
              }
            },
            {
              label: 'Não.',
              onClick: () => { }
            }
          ]
        });


      }
    }
  }
  abandonarPaciente = async () => {
    confirmAlert({
      title: 'Confirmar abandono!',
      message: 'Você tem certeza que deseja abandonar a responsabilidade sobre o paciente?',
      buttons: [
        {
          label: 'Sim!',
          onClick: () => {
            this.state.paciente.ref.update({
              responsavel: null
            });
            this.setState({
              responsavel: null,
              proprioResponsavel: false,
              confirmaResponsavel: true,
              notifition: true,
              msg: "Você abandonou a responsabilidade pelo paciente!",
              nameclass: 'alert-warning',
            })
          }
        },
        {
          label: 'Não.',
          onClick: () => { }
        }
      ]
    });
  }


  async carregar() {

    moment.locale('pt-br');
    const usuario = getLoggedInUser();
    let id = this.props.match && this.props.match.params.id ? this.props.match.params.id : this.props.id;
    this.setState({ isOnModal: id ? true : false })


    // PEGA TODOS OS PROFISSIONAIS - VERIFICAR MAIS PRA FRENTE SOBRE A LENTIDÃO
    // AQUI DEU UMA MELHORADA HOJE - 13-02-2024
    if (!this.state.profissionais || this.state.profissionais.length <= 0) {
      const profsDb = await Libfirebase.collection("usuario").where('profissao', '!=', 'Paciente').get()
      const carProf = profsDb.docs.map(it => { return { id: it.id, ref: it.ref, ...it.data() } });
      this.setState({ profissionais: carProf })
    }

    var scrlEvt = null;
    const scrlTo = (top) => {
      scrlEvt = setTimeout(() => {
        try {
          if (top > 150) {
            let conta = (top - 300);
            if (conta < 0) conta = 0;
            document.querySelector(".gb-hist-menu").style.top = conta.toFixed(2) + "px";
          } else {
            document.querySelector(".gb-hist-menu").style.top = "0px"
          }
        } catch { }
      }, 50)

    }
    window.addEventListener('scroll', () => {
      let qr = document.querySelectorAll(".full")
      if (!qr || qr.length <= 0) {
        qr = document.querySelectorAll(".pacienteONChat");
      }
      if (!qr || qr.length <= 0) {
        qr = document.querySelectorAll("html");
      }
      // console.log(1,qr);
      try {
        clearInterval(scrlEvt);
      } catch {

      }

      scrlEvt = null;
      if (qr && qr.length > 0) {
        let top = qr[qr.length - 1].scrollTop;
        // console.log('scoll', top, this.state.stopmenu)
        if (!this.state.stopmenu) {
          scrlTo(top);
        }
        if (top <= 0) {
          this.setState({ stopmenu: false }, () => {
            scrlTo(top);
          })

        }
      }
    }, true);


    if (usuario) {
      this.listHistorico(id, usuario);
      this.getData(id);
    }

    this.setState({
      idPaciente: id,
      block: (usuario.permissao.toString() === PermissaoGeral.Paciente)
    });


    let user = getLoggedInUser();
    if (user.permissao.toString() != PermissaoGeral.Paciente) {
      let user = id;
      let medic = user.cpf;

      if (!user || user == '') {
        alert('Erro ao abrir paciente!');
        /* document.body.classList.remove('noOverflow'); */

        if (this.props.closeModal) {
          this.props.closeModal();
        }

      } else {

        let userFull = await Libfirebase.doc(`/usuario/${user}`).get().then(x => x);
        let wppMsgs = await Libfirebase.collection("whatsapp").where("usuario", "==", Libfirebase.doc(`/usuario/${user}`)).where('medico', '==', Libfirebase.doc(`/usuario/${getLoggedInUser().cpf}`)).get().then(x => x);
        if (wppMsgs.docs.length <= 0) {
          wppMsgs = await Libfirebase.collection("whatsapp").where("usuario", "==", `usuario/${user}`).where('medico', '==', Libfirebase.doc(`/usuario/${getLoggedInUser().cpf}`)).get().then(x => x);
        }

        let cv = null;
        if ((userFull && userFull.data()) || (wppMsgs && wppMsgs.docs.length > 0)) {
          let wppNum = userFull.data().whatsapp;

          if ((!wppNum || typeof wppNum === 'undefined') && wppMsgs.docs.length > 0) {
            wppNum = wppMsgs.docs[0].id;
          }
          if (wppMsgs.docs.length > 0 && userFull.data().whatsapp) {
            cv = wppMsgs.docs.find(x => x.ref.path.indexOf(wppNum.replace(".", "").replace(",", "").replace(" ", "")) > 0);

          }
          if (!cv || typeof (cv) === "undefined") {
            cv = wppMsgs.docs[0];
          }


          this.setState({ wpp: cv });
        }
      }

    }

    this.verificarAtendimento();
    this.listenMensagens(id);
  }

  // static getDerivedStateFromProps(nextProps, nextState) {
  //   console.log("passou em getDerivedStateFromProps")
  //   if (nextProps.usuario !== nextState.usuario) {
  //     return {
  //       usuario: nextProps.usuario
  //     };
  //   }

  //   return null;
  // }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.usuario !== prevState.usuario) {
      //this.getData(this.props.match.params.id, this.state.usuario);
    }

    if ((this.props.match && this.props.match.params.id ? this.props.match.params.id : this.props.id) !== this.state.idPaciente) {
      this.setState({ idPaciente: (this.props.match && this.props.match.params.id ? this.props.match.params.id : this.props.id) });
      //this.getData(this.props.match.params.id, this.state.usuario);
    }

    if (this.state.card === "mensagens") {
      try {
        if (typeof (this.inputMessage) != "undefined" && this.inputMessage) {
          if (typeof this.inputMessage.focus != "undefined")
            this.inputMessage.focus();
        }
      } catch (e) {
        console.log('error', e);
      }
    }
  }

  listHistorico = async (id, usuario) => {
    try {
      this.setState({ loadingHist: true })

      await getListHistorico(id, usuario)
        .then(async (historico) => {
          let conta = 0;
          historico.onSnapshot(async (snap) => {
            let listHistorico = [];
            let list = [];

            snap.docs.forEach(async doc => {
              let item = doc.data();
              let data = {
                id: doc.id,
                historico: item,
                profissional: ''
              };
              list.push(data);
            });

            for (let item of list) {
              let data = {
                idPaciente: id,
                id: item.id,
                historico: item.historico,
                profissional: this.state.profissionais.filter(x => x.id === item.historico.refProfissional.id)[0],
                listMidia: [],
                c: conta,
                type: 'historico'
              };
              if (item.historico.DataCriacao && item.historico.DataCriacao.split('-').length > 0) {
                const dataAux = item.historico.DataCriacao.split('-')
                data.dt = dataAux[2] + "-" + dataAux[1] + "-" + dataAux[0] + " " + item.historico.Hora;
              }

              await getListMidia(item.id, id).then(async (midia) => {
                data.listMidia = midia;
              });

              listHistorico.push(data);
            }

            const setDOM = (list) => {
              console.log('LIIIST-->,', list)
              list = list.sort(function (a, b) {
                if (moment(b.dt, 'YYYY-MM-DD hh:mm:ss').unix() < moment(a.dt, 'YYYY-MM-DD hh:mm:ss').unix()) {
                  return -1;
                } else
                  if (moment(b.dt, 'YYYY-MM-DD hh:mm:ss').unix() > moment(a.dt, 'YYYY-MM-DD hh:mm:ss').unix()) {
                    return 1;
                  } else
                    return 0;
              }
              );
              this.setState({
                historico: list,
                loadingHist: false,
              })
            }
            setDOM(listHistorico);


            let coments = Libfirebase.collection("paciente")
              .doc(id)
              .collection("Comentarios");

            if (!coments) {
              return;
            }
            try {
              coments.onSnapshot(async (z) => {
                console.log('snapppppp comennnttss', z)
                this.setState({
                  loadingHist: true
                });

                let contaDocs = 0;
                for (let com of z.docChanges()) {
                  if (true || com.type === "added") {
                    var prof = this.state.profissionais.find(x => x.id === com.doc.data().refProfissional.id);

                    let data = {
                      nomeProfissional: prof ? prof.nome : '',
                      idPaciente: id,
                      id: com.doc.id,
                      type: 'comentario',
                      comentario: com.doc.data(),
                      c: conta,
                      dt: com.doc.data().data
                    };
                    listHistorico.push(data);
                    contaDocs++;
                  }
                }
                setDOM(listHistorico)
              });
            } catch { }

          })
          // this.getAnexos();

        })
        .catch(erro => {
          this.setState({
            msg: erro.code,
            notifition: true,
            nameclass: "alert-danger"
          });
        });
    } catch { }
  }

  getData = async (id) => {
    this.setState({
      carregando: true,
      preloadAtestado: true,
      preloadCirurgia: true,
      preloadReceita: true,
      preloadReceituario: true,
      preloadSolicExame: true,
      preloadMensagens: true,
      preloadAuditoria: true
    });

    try {
      await getPaciente(id)
        .then(async (paciente) => {
          this.setState({ paciente, status: paciente.paciente.status });

          if ((getLoggedInUser().permissao.toString() === PermissaoGeral.Administrador ||
            getLoggedInUser().permissao.toString() === PermissaoGeral.Médico) &&
            paciente.paciente.status === 'Aguardando Análise' &&
            (!paciente.paciente.responsavel || paciente.paciente.responsavel == null)) {
            this.setState({ confirmaResponsavel: true });

          } else if (paciente && paciente.paciente && paciente.paciente.responsavel) {
            let responsavel = null;
            await paciente.paciente.responsavel.get().then(dd => {
              if (dd.exists) {
                responsavel = { id: dd.id, ref: dd.ref, ...dd.data() };
              }
            });
            let proprioResponsavel = responsavel && getLoggedInUser().cpf === responsavel.CPF;
            // console.log('RESP', responsavel, proprioResponsavel, getLoggedInUser());
            this.setState({ responsavel, proprioResponsavel });
          }
        })
        .catch(erro => {
          console.log("ERRO", erro);
          this.setState({
            msg: erro,
            notifition: true,
            nameclass: "alert-danger"
          });
        });

      // pegar esses só quando clicar no menu não mais no carregamento da pagina
      //   this.getAtestados()
      //   this.getCirurgias()
      //  this.getReceitas()
      //   this.getReceituarios()
      //   this.getExames()
      // await this.getAnexosData();
      // await this.carregaMensagens();
    } catch { }

    this.setState({ new: false, carregando: false });
  };



  handleClick = () => {
    // e.preventDefault();
    this.setState({ visible: !this.state.visible });

  };

  calcularIdade = data => {
    var today = new Date();
    var birthDate = new Date(data); // create a date object directly from `data` argument
    var age_now = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age_now--;
    }

    return age_now;
  };

  renderDataScreenCard(valor) {
    console.log("valor------------------", valor)
    switch (valor) {
      case 'receita':
        this.getReceitas();
        break;
      case 'receituario':
        this.getReceituarios();
        break;
      case 'atestado':
        this.getAtestados();
        break;
      case 'cirurgia':
        this.getCirurgias();
        break;
      case 'exames':
      case 'exame':
        this.getExames();
        break;
      case 'anexos':
      case 'anexo':
        this.getAnexosData();
        break;
      case 'auditoria':
        this.getAuditoriasData();
        break;
      case 'mensagens':
        this.carregaMensagens();
        break;

      default:
        break;
    }
  }

  renderCard = (e, valor) => {
    if (e) {
      e.preventDefault();
    }

    let qr = document.querySelectorAll(".full")
    if (!qr || qr.length <= 0) {
      qr = document.querySelectorAll(".pacienteONChat");
    }

    let top = 0
    if (qr && qr.length > 0) {
      top = qr[qr.length - 1].scrollTop;
    }


    this.setState({ stopmenu: top > 0 }, () => {

      this.setState({ card: valor });
      // console.log(this.divConteudo);
      if (this.divConteudo && this.divConteudo.current) {
        this.divConteudo.current.scrollTop = 0;

        window.document.querySelectorAll(".full").forEach(ee => {
          ee.scroll(0, 0);
        })
        window.document.querySelectorAll(".pacienteONChat").forEach(ee => {
          ee.scroll(0, 0);
        })

      }
    })

    this.renderDataScreenCard(valor)
  };

  selectMenu = (valor) => {
    let card = this.state.menu.filter(x => x.descricao == valor)[0];
    console.log(card);
    this.renderCard(null, card.card);
  }

  async getReceitas() {
    await getListReceita(this.state.idPaciente, this.state.usuario)
      .then(async (receita) => {
        let listReceita = [];
        listReceita = await receita.map(item => {
          return {
            idPaciente: this.state.idPaciente,
            id: item.id,
            receita: item.receita,
            profissional: this.state.profissionais.find(x => x.id === item.receita.refProfissional.id)
          };
        });

        listReceita = listReceita.sort((a, b) => {
          return (moment(a.receita.DataCriacao, 'DD-MM-YYYY').unix() > moment(b.receita.DataCriacao, 'DD-MM-YYYY').unix() ? 1 : -1)
        });

        this.setState({ receita: listReceita, preloadReceita: false });
      })
      .catch(erro => {
        this.setState({
          msg: erro.code,
          notifition: true,
          nameclass: "alert-danger"
        });
      });
  }
  async getReceituarios() {
    await getListReceituario(this.state.idPaciente, this.state.usuario)
      .then(async (receituario) => {
        let listReceituario = await receituario.map(item => {
          return {
            idPaciente: this.state.idPaciente,
            id: item.id,
            receituario: item.receituario,
            profissional: this.state.profissionais.find(x => x.id === item.receituario.refProfissional.id)
          };
        });

        listReceituario = listReceituario.sort((a, b) => {
          return (moment(a.receituario.DataCriacao, 'DD-MM-YYYY').unix() > moment(b.receituario.DataCriacao, 'DD-MM-YYYY').unix() ? 1 : -1)
        });

        this.setState({ receituario: listReceituario, preloadReceituario: false });

      })
      .catch(erro => {
        this.setState({
          msg: erro.code,
          notifition: true,
          nameclass: "alert-danger"
        });
      });
  }
  async getAtestados() {
    await getListAtestado(this.state.idPaciente, this.state.usuario)
      .then(async (atestado) => {
        let listAtestado = await atestado.map(item => {
          return {
            idPaciente: this.state.idPaciente,
            id: item.id,
            atestado: item.atestado,
            profissional: this.state.profissionais.find(x => x.id === item.atestado.refProfissional.id)
          };
        });

        listAtestado = listAtestado.sort((a, b) => {
          return (moment(a.atestado.DataCriacao, 'DD-MM-YYYY').unix() > moment(b.atestado.DataCriacao, 'DD-MM-YYYY').unix() ? 1 : -1)
        });
        this.setState({ atestado: listAtestado, preloadAtestado: false });

      })
      .catch(erro => {
        this.setState({
          msg: erro.code,
          notifition: true,
          nameclass: "alert-danger"
        });
      });
    this.setState({ preloadAtestado: false });
  }
  async getCirurgias() {
    await getListCirurgia(this.state.idPaciente, this.state.usuario)
      .then(async (cirurgia) => {
        let listCirurgia = await cirurgia.map(item => {
          return {
            idPaciente: this.state.idPaciente,
            id: item.id,
            cirurgia: item.cirurgia,
            profissional: this.state.profissionais.find(x => x.id === item.cirurgia.refProfissional.id)
          };

        });
        listCirurgia = listCirurgia.sort((a, b) => {
          return (moment(a.cirurgia.DataCriacao, 'DD-MM-YYYY').unix() > moment(b.cirurgia.DataCriacao, 'DD-MM-YYYY').unix() ? 1 : -1)
        });
        this.setState({ cirurgia: listCirurgia, preloadCirurgia: false });
      })
      .catch(erro => {
        this.setState({
          msg: erro.code,
          notifition: true,
          nameclass: "alert-danger"
        });
        this.setState({ preloadCirurgia: false });

      });
  }
  async getExames() {
    await getSolicitacaoExames(this.state.idPaciente).then(async (x) => {
      let list = await x.map((item) => {
        return {
          profissional: this.state.profissionais.find(x => x.id === item.refProfissional.id),
          ...item
        };
      });

      list = list.sort((a, b) => {
        return (moment(a.DataCriacao, 'DD-MM-YYYY').unix() > moment(b.DataCriacao, 'DD-MM-YYYY').unix() ? 1 : -1)
      });
      this.setState({
        solicitacaoExames: list,
        preloadSolicExame: false
      });
    });
  }

  async getAnexosData() {
    try {
      this.setState({ preloadAnexos: true });
      const { historico, riscoCirurgico } = this.state;

      let anexos = [];
      if (historico) {
        for (let item of historico) {
          if (item.listMidia) {
            for (let midia of item.listMidia) {
              let obj = midia.midia;
              let src = obj.linkStorage ? 'https://us-central1-globalbrain-ba498.cloudfunctions.net/pdf/getCardiofit?link=' + obj.linkStorage : obj.url;
              obj.src = src;
              anexos.push(obj);
            }
          }
        }
      }
      if (riscoCirurgico) {
        for (let item of riscoCirurgico) {
          for (let midia of item.riscoCirurgico.midias) {
            let src = midia.linkStorage ? 'https://us-central1-globalbrain-ba498.cloudfunctions.net/pdf/getCardiofit?link=' + midia.linkStorage : midia.url;
            midia.src = src;
            anexos.push(midia);
          }
        }
      }

      await Libfirebase.collection("paciente")
        .doc(this.state.paciente.id)
        .collection("anexos")
        .get().then(snap => {
          snap.docs.forEach(function (change) {

            let src = change.data().linkStorage ? 'https://us-central1-globalbrain-ba498.cloudfunctions.net/pdf/getCardiofit?link=' + change.data().linkStorage : change.data().url;
            anexos.push({ src, ...change.data() });
          });
        });


      anexos = anexos.sort((a, b) => {
        if (a && b && a.data && b.data) {
          if (moment(a.data, 'YYYY-MM-DD HH:mm').unix() > moment(b.data, 'YYYY-MM-DD HH:mm').unix()) {
            return 1;
          } else {
            return -1;
          }
        } else {

          return 1;
        }
      });
      this.setState({ anexos, preloadAnexos: false });
    } catch { }

    //console.log('anexos', anexos);
  }

  getAnexos = async () => {
    this.renderCard(null, "anexos");
    await this.getAnexosData();
  };

  carregaMensagens = async () => {
    await getMensagens(this.state.idPaciente).then(async (x) => {
      x.onSnapshot(async (exs) => {
        //  await Libfirebase.collection('conversas').where('user2.id', '==', id_paciente).get().then(async(exs)=>{
        console.log('msg---------')
        let arr_conversas = [];

        let conversas = exs.docs.map(item => {
          return {
            id: item.id, ref: item.ref, ...item.data()
          }
        });

        for (let c of conversas) {
          await c.ref.collection('mensagens').get().then(msg => {
            c.mensagens = msg.docs.map(item => {
              return {
                id: item.id, ref: item.ref, ...item.data()
              }
            });
          });

          for (let m of c.mensagens) {
            let busca = arr_conversas.filter(x => x.data == moment(m.data_envio.toDate()).format('YYYY-MM-DD') && x.id === c.user1.id);
            if (busca.length > 0) {
              //m.data_envio = m.data_envio.toDate();
              busca[0].mensagens.push(m);
            } else {
              arr_conversas.push({
                data: moment(m.data_envio.toDate()).format('YYYY-MM-DD'),
                data_desc: moment(m.data_envio.toDate()).format('DD/MM/YYYY'),
                id: c.user1.id,
                nome: c.user1.nome,
                avatarURL: c.user1.avatarURL,
                mensagens: [m]
              });
            }
          }
        }

        arr_conversas.sort(function (a, b) { return moment(b.data) - moment(a.data) });

        this.setState({
          mensagens: arr_conversas,
          preloadMensagens: false
        }, function () {
          if (this.state.card === "mensagens" && this.divConteudo && this.divConteudo.current) {
            this.divConteudo.current.scrollTop = 9999999;
          }
        });

      })

    });
  }

  getMensagens = async () => {
    this.renderCard(null, "mensagens");
  }

  async getAuditoriasData() {
    this.setState({ preloadAuditoria: true })
    await getAuditorias(this.state.idPaciente).then(async (x) => {
      let list = await x.map((item) => {
        let prof = this.state.profissionais.find(x => x.ref.path === item.refProfissional)
        let profFim = item.profissional_finalizou ?
          this.state.profissionais.find(x => x.ref.path === item.profissional_finalizou) :
          null

        return {
          profissional: prof ? prof.nome : "",
          usuarioFinalizou: profFim ? prof.nome : "",
          ...item
        };
      });

      list = list.sort((a, b) => {
        return (moment(a.created_at, 'DD-MM-YYYY').unix() > moment(b.created_at, 'DD-MM-YYYY').unix() ? 1 : -1)
      });
      this.setState({
        auditorias: list,
        preloadAuditoria: false
      });
    });
  }

  handleUploadSuccess = async filename => {
    const downloadURL = await firebaseStorage
      .ref("receitas")
      .child(filename)
      .getDownloadURL();

    // Libfirebase.collection('paciente')
    // .doc(this.state.paciente.id)
    // .collection('anexos')
    // .add({url : downloadURL})

    this.setState(oldState => ({
      filenames: [...oldState.filenames, filename],
      downloadURLs: downloadURL,
      uploadProgress: 100,
      isUploading: false
    }));
  };

  setAnexo = async (nomearquivo) => {
    if (this.state.downloadURLs.length > 0) {

      if (nomearquivo) {

        var loggedUser = getLoggedInUser();
        this.setState({ preloadAnexos: true });
        await Libfirebase.collection("paciente")
          .doc(this.state.paciente.id)
          .collection("anexos")
          .add({
            url: this.state.downloadURLs,
            nome: nomearquivo,
            data: moment().add(3, "hours").format("YYYY-MM-DD HH:mm:ss"),
            refProfissional: Libfirebase.collection('usuarios').doc(loggedUser.cpf)
          })
          .then(() => {
            alert("Arquivo anexado com sucesso!");
            this.setState({ downloadURLs: [], nomearquivo: "", preloadAnexos: false });
          })
          .catch(error => alert(error.code));

        this.carregar();

      } else {

        alert("É preciso digitar o nome para o arquivo");
      }
    } else {

      alert("É preciso anexar um PDF");
    }
  };

  _setStatus = async (value) => {
    const { idPaciente } = this.state;

    if (value === "Aguardando Cirurgia") {
      this.setState({ openMDLCAD: true, modalOBJ: 'cirurgia' });
    }

    if (value === "Finalizado") {
      this.state.paciente.ref.update({
        responsavel: null
      });
      this.setState({
        responsavel: null,
        proprioResponsavel: false
      })
    }
    let user = await getLoggedInUser();
    console.log("vai finalizar", this.props.agenda, user)
    if (this.props.agenda) {
      finalizarAtendimentoPaciente(this.props.agenda.ref, this.props.agenda.agenda, user);
    }



    this.setState({ status: value, notifition: false, msg: "", nameclass: "" });

    Libfirebase.collection("paciente")
      .doc(idPaciente)
      .update({ status: value })
      .then(() => {
        if (
          value === "Acompanhamento Ambulatorial" ||
          value === "Acompanhamento Pós Operatório"
        ) {
          this.setState({ openModalRetorno: true });
        }
        this.setState({
          openModal: false,
          notifition: true,
          msg: "Status alterado com sucesso!",
          nameclass: "alert-success"
        });

      })
      .catch(error => {
        this.setState({
          openModal: false,
          status: null,
          notifition: true,
          msg: "Houve um erro ao salvar o status",
          nameclass: "alert-danger"
        });
      });
  };
  _cadastrarRetorno = () => {
    const { idPaciente, dataRetorno } = this.state;
    var data = {
      DataRetorno: moment(dataRetorno).format("DD-MM-YYYY")
    };
    updatePaciente(idPaciente, data)
      .then(() => {
        this.setState({ openModalRetorno: false });
        this.setState({
          notifition: true,
          msg: "Retorno cadastrado com sucesso!"
        })
      })
      .catch(error =>
        this.setState({
          notifition: true,
          msg: error,
          nameclass: "alert-danger"
        })
      );
  };

  _cadastrarUsuario = async () => {
    const user = firebaseAuth.currentUser;

    let usuario = null;
    await Libfirebase.collection('usuario').where('email', '==', user.email).get().then((res) => {

      usuario = res.docs[0].data();
    });


    firebaseAuth.createUserWithEmailAndPassword(
      this.state.paciente.paciente.email,
      this.state.paciente.paciente.cpf.substring(0, 7).replace(".", "").replace(".", "").replace(" ", "")
    ).then((res) => {

      updatePaciente(this.state.idPaciente, {
        "userUID": res.user.uid
      }).then(() => {
        this.state.paciente.paciente.userUID = res.user.uid;

        firebaseAuth
          .signInWithEmailAndPassword(usuario.email, usuario.senha)
          .then(user => {


          }).catch((err) => {

          });

        alert("Usuário cadastrado com sucesso!");
        this.setState(this.state.paciente.paciente);

      });


    }).catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;

      alert("Erro ao cadastrar usuário! \n\n" + error.message);

      // ...
    });
  }

  _setResponder(id, type, desc, prof) {

    prof.get().then((pf) => {

      desc = desc.replace("||", pf.data().nome);
      let idComent = {
        type,
        id,
        desc
      };
      this.state.idComent = idComent;
      this.setState({ idComent });
      this.forceUpdate();
      this.state.setFocus = true;
      this.setState({ setFocus: true });
    });

  }
  _setComentario = (coment) => {

    const profissional = getLoggedInUser();
    const ref = Libfirebase.collection("paciente")
      .doc(this.state.idPaciente)
      .collection("Comentarios");

    this.setState({ notifition: false, loadingHist: true });
    const refProfissional = Libfirebase.collection("usuario").doc(
      profissional.cpf
    );
    let refComent = null;
    if (this.state.idComent) {
      if (this.state.idComent.type === 'coment')
        refComent = ref.doc(this.state.idComent.id);
      else
        refComent = Libfirebase.collection("paciente").doc(this.state.idPaciente).collection('historico').doc(this.state.idComent.id);

    }
    if (coment) {
      ref
        .add({
          comentario: coment,
          refProfissional,
          dataHoraCriacao: moment().format("DDMMYYYYHHmmss"),
          data: moment().format("YYYY-MM-DD HH:mm:ss"),
          refComent: (refComent ? refComent : null),
          refType: (this.state.idComent ? this.state.idComent.type : null),
          refDesc: (this.state.idComent ? this.state.idComent.desc : null)

        })
        .then(async () => {
          const usuario = getLoggedInUser();
          const id = this.props.id ? this.props.id : this.props.match.params;

          if (usuario) {
            //this.getData(id, usuario);
            this.setState({
              notifition: true,
              msg: "Comentário adicionado com sucesso!",
              nameclass: "alert-success",
              idComent: null
            });
            if (hasPermission([PermissaoGeral.Administrador, PermissaoGeral.Médico])) {
              // this.setState({
              //   openAlteraStatusModal: true,
              // });
            } else {
              await Libfirebase.collection("paciente")
                .doc(this.state.idPaciente)
                .update({ status: "Aguardando Análise" })
                .then(() => {

                })
                .catch(error => {

                });
            }
            //getListHistorico(id, usuario);

          }
          //this.state.txtComent =  null;
          this.state.idComent = null;
          this.setState({
            idComent: null

          });

          //await this.listHistorico(id, usuario);

          //this.forceUpdate();
        })
        .catch(error => {
          this.state.idComent = null;

          this.setState({
            idComent: null
          });
        });
    } else {
      this.state.idComent = null;

      this.setState({
        notifition: true,
        msg: "Favor preencher o comentário!",
        nameclass: "alert-warning",
        idComent: null
      });
    }

    this.setState({ loadingHist: false });
  };

  _setCIDAtendimento = async () => {
    const { idPaciente } = this.state;
    if (this.state.interacao && this.state.atendimentoObj) {
      await this.state.atendimentoObj.ref.update({
        CID: this.state.CID2,
      });
    }
    this.setState({
      openModalCID: false,
      CID: this.state.CID2
    })
  }

  _setStatus2 = async (value) => {
    const { idPaciente } = this.state;
    const { dataRetorno } = this.state;

    // console.log("this.state.status", this.state.status)
    if (!this.state.CID || this.state.CID === "") {
      return toast.error("Informe o CID")
    }

    if (!this.state.status || this.state.status === "") {
      return toast.error("Informe o Status")
    }

    this.setState({ status: value, notifition: false, msg: "", nameclass: "" });
    if (value === "Finalizado") {
      this.state.paciente.ref.update({
        responsavel: null
      });
      this.setState({
        responsavel: null,
        proprioResponsavel: false
      })
    }

    let user = await getLoggedInUser();
    console.log("vai finalizar", this.props.agenda, user)
    if (this.props.agenda) {
      finalizarAtendimentoPaciente(this.props.agenda.ref, this.props.agenda.agenda, user);
    }

    if (this.state.dataRetorno) {
      await Libfirebase.collection("paciente")
        .doc(idPaciente)
        .update({
          status: value,
          DataRetorno: moment(dataRetorno).format("DD-MM-YYYY")
        })
        .then(() => {
          this.setState({
            openAlteraStatusModal: false,
            notifition: true,
            msg: "Status alterado com sucesso!",
            nameclass: "alert-success"
          });

        })
        .catch(error => {
          this.setState({
            openAlteraStatusModal: false,
            status: null,
            notifition: true,
            msg: "Houve um erro ao salvar o status",
            nameclass: "alert-danger"
          });
        });
    } else {
      await Libfirebase.collection("paciente")
        .doc(idPaciente)
        .update({ status: value })
        .then(() => {
          this.setState({
            openAlteraStatusModal: false,
            notifition: true,
            msg: "Status alterado com sucesso!",
            nameclass: "alert-success"
          });
        })
        .catch(error => {
          this.setState({
            opeopenAlteraStatusModalnModal: false,
            status: null,
            notifition: true,
            msg: "Houve um erro ao salvar o status",
            nameclass: "alert-danger"
          });
        });
    }
    if (this.state.interacao && this.state.atendimentoObj) {
      await this.state.atendimentoObj.ref.update({
        situacao: 'finalizado',
        data_finalizado: moment().format('YYYY-MM-DD HH:mm:ss'),
        CID: this.state.CID,

      });
      this.setState({
        interacao: false,
        atendimentoId: null,
        atendimentoObj: null,

      }, () => {
        this.verificarAtendimento();
      })
    }

    if (this.state.CID) {
      let pac = await Libfirebase.collection("paciente")
        .doc(idPaciente).get();
      if (pac.data()) {
        let doencas = pac.data().doencas;
        if (!doencas) {
          doencas = [];
        }
        let has = doencas.find(x => x.codigo === this.state.CID.value.codigo);
        if (!has) {
          doencas.push(this.state.CID.value);
          await Libfirebase.collection("paciente")
            .doc(idPaciente)
            .update({ doencas });
        }
      }
      console.log('paciente', pac.data());
    }


    this.carregar();

  };

  _clearIdComent = () => {
    this.state.idComent = null;
    this.setState({
      idComent: null,
      txt: ''
    });
  }


  async sendMessage(mensagem) {
    if (!mensagem || mensagem === '') {
      alert("Digite uma mensagem!");
    } else {
      let userref = {};
      await getRef('usuario', this.state.idPaciente).then(async (result) => {
        userref = result;
      });

      let conv = await Libfirebase.collection('conversas').where('users', 'array-contains', this.state.idPaciente).get().then(x => x);
      if (conv.docs.length > 0) {
        conv = conv.docs.filter(x => x.data().users.includes(getLoggedInUser().cpf));
        if (conv.length > 0) {
          conv = conv[0];
          let convData = conv.data();

          let usuario = {
            nome: getLoggedInUser().firstName,
            id: getLoggedInUser().cpf,
            avatarURL: (getLoggedInUser().avatarURL && getLoggedInUser().avatarURL != '' ? getLoggedInUser().avatarURL : ''),
            reference: userref
          };

          let msg = {
            data_envio: new Date(),
            mensagem: mensagem,
            visualizado: false,
            tipo_mensagem: "texto",
            usuario
          }
          convData.mensagem = msg;
          // this.inputMessage.value = "";
          //this.inputMessage.focus();
          console.log(this.state.wpp.id, "👨‍⚕️ " + usuario.nome + " diz:\n\n" + msg.mensagem)
          if (this.state.wpp) {
            sendWhatsappMessage(this.state.wpp.id, "👨‍⚕️ " + usuario.nome + " diz:\n\n" + msg.mensagem);
            sendWhatsappMessage(this.state.wpp.data().phoneGroup, "👨‍⚕️ Você disse através da plataforma WEB:\n\n" + msg.mensagem);
            msg.tipo_envio = 'whatsapp';
          }
          saveMessage(convData, msg, conv.id).then(async (r) => {
            await this.carregaMensagens();

          });

        }
      }
    }
  }

  async openIMAGEVIEWER(images, showImgIndex) {
    this.setState({
      showImg: true,
      images,
      showImgIndex
    })
  }

  newCirurgia() {
    let hasCirurgiaAndamento = this.state.cirurgia && this.state.cirurgia.length > 0 ? this.state.cirurgia.filter(x => !x.cirurgia.realizada && !x.cirurgia.cancelada) : null;
    console.log("ERRO", hasCirurgiaAndamento)
    if (hasCirurgiaAndamento && hasCirurgiaAndamento.length >= 1) {
      alert('Já existe uma cirurgia em andamento para este paciente!');
    } else {
      this.setState({ openMDLCAD: true, modalOBJ: 'cirurgia' })
    }
  }

  getAction() {
    if (this.state.interacao) {
      if (this.state.card == 'historico') {
        return <Link
          to="#"
          className="btn gb-button"
          onClick={() => { this.setState({ openMDLCAD: true, modalOBJ: 'queixa' }) }}>
          <i className="fa fa-plus" /> Nova Queixa
        </Link>
      } else if (this.state.card == 'receita' && !this.state.block) {
        return (<>
          <button
            onClick={() => window.open("https://us-central1-globalbrain-ba498.cloudfunctions.net/pdf/receituario?result=download&id=" + this.state.paciente.id, "_blank")}
            style={{ marginLeft: 15 }}
            className="btn gb-button-border">
            Receita Vazia Assinada
          </button>
          <Link
            to="#"
            onClick={() => { this.setState({ openMDLCAD: true, modalOBJ: 'receita' }) }}
            className="btn gb-button ml-3"
          >
            <i className="fa fa-plus" /> Nova
          </Link>
        </>)
      } else if (this.state.card == 'receituario' && !this.state.block) {
        return <Link
          to="#"
          onClick={() => { this.setState({ openMDLCAD: true, modalOBJ: 'receituario' }) }}
          className="btn gb-button"
        >
          <i className="fa fa-plus" /> Nova Prescrição
        </Link>
      } else if (this.state.card == 'atestado' && !this.state.block) {
        return <Link
          to="#"
          onClick={() => { this.setState({ openMDLCAD: true, modalOBJ: 'atestado' }) }}
          className="btn gb-button">
          <i className="fa fa-plus" /> Novo Atestado
        </Link>
      } else if (this.state.card == 'cirurgia' && !this.state.block) {
        return <Link
          to="#"
          className="btn gb-button"
          onClick={() => { this.newCirurgia() }}
        >
          <i className="fa fa-plus" /> Novo Registro
        </Link>
      } else if (this.state.card == 'exames' && !this.state.block) {
        return <Link
          to="#"
          className="btn gb-button"
          onClick={() => { this.setState({ openMDLCAD: true, modalOBJ: 'exame' }) }}
        >
          <i className="fa fa-plus" /> Novo Exame
        </Link>
      } else if (this.state.card == 'anexos' && !this.state.block) {
        return <Link
          to="#"
          className="btn gb-button"
          onClick={() => { this.setState({ openMDLCAD: true, modalOBJ: 'anexo' }) }}
        >
          <i className="fa fa-plus" /> Novo Anexo
        </Link>
      }
      // else if (this.state.card == 'auditoria' && !this.state.block) {
      //   return <Link
      //     to="#"
      //     className="btn gb-button"
      //     onClick={() => { this.setState({ openMDLCAD: true, modalOBJ: 'auditoria' }) }}
      //   >
      //     <i className="fa fa-plus" /> Nova Auditoria
      //   </Link>
      // }

    }
  }

  openImageAnexo(index) {
    this.setState({ images: this.state.anexos, showImg: true, showImgIndex: index });
  }

  editImageAnexo(url) {
    this.setState({ editImage: true, editImageSrc: url, display: 'block' });
  }

  iniciarConversa() {
    this.props.initCall(this.state.paciente)
    this.props.closeModal()
  }

  /* VÍDEO CHAMADA */
  // escuta se tem mensagem daquele paciente chegando para saber se tem video chamada
  async listenMensagens(idPaciente) {
    getConversations(null, idPaciente).then((r) => {
      if (r) {
        r.onSnapshot(async (cvn) => {
          let lsta = cvn.docs;
          let lst = [];
          for (let element of lsta) {
            let obj = {
              id: { "ref": element.ref, ...element.data() },
              idd: element.id,
              mensagem: element.data().mensagem,
              usuario: (idPaciente === element.data().user1.id ? element.data().user2 : element.data().user1)
            }
            lst.push(obj);
          }

          lst = lst.filter(x => x.mensagem).sort((a, b) => {
            return a.mensagem && b.mensagem &&
              a.mensagem.data_envio &&
              moment(a.mensagem.data_envio.toDate()).isAfter(moment(b.mensagem.data_envio.toDate())) ? -1 : 1
          })

          const cnt = lst.filter(x =>
            x && x.mensagem &&
            x.mensagem.usuario &&
            x.mensagem.usuario.id !== idPaciente &&

            (!x.mensagem.visualizado || x.mensagem.visualizado === false)
          );

          let msgReceived = cnt[cnt.length - 1]; // ESTAVA AQUI
          if (msgReceived && msgReceived.mensagem && msgReceived.mensagem.tipo_mensagem === "videocall"
            && msgReceived.mensagem.data_atendeu === null && msgReceived.mensagem.data_desligou === null) {
            console.log("msgReceived.idd", msgReceived.idd)
            this.setState({
              recebendoLigacaoObj: msgReceived,
              recebendoLigacaoObjID: msgReceived.idd,
              recebendoLigacao: true,
            })
          } else {
            this.setState({
              recebendoLigacaoObj: null,
              recebendoLigacaoObjID: null,
              recebendoLigacao: false,
            });
          }
        });
      }
    })
  }

  acceptCall() {
    let msg = this.state.recebendoLigacaoObj;
    if (msg) {
      msg.id.mensagem.data_atendeu = new Date();
      msg.id.mensagem.visualizado = true;

      console.log("recebendoLigacaoObjID", this.state.recebendoLigacaoObjID)

      updateConversa(this.state.recebendoLigacaoObjID, msg.id);

      updateMessage(this.state.recebendoLigacaoObjID, msg.id.mensagem.reference.id, msg.id.mensagem);

      this.setState({
        recebendoLigacao: false,
        startCall: true,
        channel: this.state.recebendoLigacaoObjID,
        uid: this.props.cpf,
        emLigacao: true,
        ligacaoObj: msg,
        ligacaoObjID: this.state.recebendoLigacaoObjID,
      });
    }
  }

  finishCall() {
    let msg = this.state.ligacaoObj;

    // if (msg === null) {
    //   this.endCall();
    //   return
    // }

    if (msg) {
      msg.id.mensagem.data_desligou = new Date();

      updateConversa(this.state.ligacaoObjID, msg.id);
      updateMessage(this.state.ligacaoObjID, msg.id.mensagem.reference.id, msg.id.mensagem);

      this.setState({
        recebendoLigacaoObj: null,
        recebendoLigacaoObjID: null,
        recebendoLigacao: false,
        startCall: false,
        channel: "",
        uid: "",
        emLigacao: false
      });
    }
  }

  /* -------------------- */


  render() {
    return (
      <div>
        {this.state.recebendoLigacao &&
          <div className="float_call_button" onClick={() => { this.acceptCall() }}>
            <i className="tilt-shaking fa fa-phone"></i><span>atender</span>
          </div>
        }

        <VideoCallComponent
          startCall={this.state.startCall}
          channel={this.state.channel}
          emLigacao={this.state.emLigacao}
          usuarioLigando={this.state.recebendoLigacaoObj && this.state.recebendoLigacaoObj.usuario}
          finishCall={this.finishCall}
        />

        <ModalComponent
          openModal={this.state.openMDLCAD}
          auto={((this.state.modalOBJ == 'cirurgia') || (this.state.modalOBJ == 'anexo'))}
          closeModal={() => {
            /* document.body.classList.remove('noOverflow'); */
            this.setState({ openMDLCAD: false });
            this.renderDataScreenCard(this.state.modalOBJ)
          }}
          closed={() => { /* document.body.classList.remove('noOverflow'); */ this.setState({ openMDLCAD: false }); }}
          newstyles={{ zIndex: '99999999 !important' }}
          modalSecundario={true}
        >
          {this.state.modalOBJ == 'queixa' ?
            <Queixa id={this.state.idPaciente}
              onClose={() => {
                this.setState({ openMDLCAD: false })
                this.carregar();
              }} /> : null}
          {this.state.modalOBJ == 'receita' ?
            <CadastroReceita modoModal={true} id={this.state.idPaciente}
              onClose={() => {
                this.setState({ openMDLCAD: false })
                this.getReceitas();
              }} /> : null}

          {this.state.modalOBJ == 'receituario' ?
            <CadastrarReceituario modoModal={true} id={this.state.idPaciente}
              onClose={() => {
                this.setState({ openMDLCAD: false })
                this.getReceituarios();
              }} /> : null}

          {this.state.modalOBJ == 'atestado' ?
            <CadastrarAtestado modoModal={true} id={this.state.idPaciente}
              onClose={() => {
                this.setState({ openMDLCAD: false })
                this.getAtestados();
              }} /> : null}

          {this.state.modalOBJ == 'cirurgia' ?
            <CadastrarCirurgia modoModal={true} id={this.state.idPaciente}
              onClose={() => {
                this.setState({ openMDLCAD: false })
                this.getCirurgias();
              }} /> : null}

          {this.state.modalOBJ == 'exame' ?
            <CadastrarExame modoModal={true} id={this.state.idPaciente}
              onClose={() => {
                this.setState({ openMDLCAD: false })
                this.getExames();
              }} /> : null}

          {this.state.modalOBJ == 'anexo' ?
            <CadastrarAnexo modoModal={true}
              id={this.state.idPaciente}
              setAnexo={this.setAnexo}
              handleUploadSuccess={this.handleUploadSuccess}
              onClose={() => {
                this.setState({ openMDLCAD: false })
                this.getAnexos();
              }} /> : null}

          {this.state.modalOBJ == 'auditoria' ?
            <CadastrarAuditoria
              idPaciente={this.state.idPaciente}
              profissional={this.state.usuario}
              onClose={() => {
                this.setState({ openMDLCAD: false })
                this.getAuditoriasData()
              }} /> : null
          }

        </ModalComponent>

        <ModalComponent
          openModal={this.state.editImage}
          closeModal={() => this.setState({ editImage: false })}
          modalSecundario={true}
          styles={{
            content: {
              top: '0px',
              left: '0px',
              right: '0px',
              bottom: '0px',
              marginRight: '',
              position: 'fixed',
              zIndex: '99999999999999999999999999999 !important'

            }
          }}
        >
          <div style={{ height: '98%' }}>
            <ImageEditor
              includeUI={{
                loadImage: {
                  path: this.state.editImageSrc,
                  name: 'a',
                  url: this.state.editImageSrc
                },
                menu: ['crop', 'flip', 'rotate', 'draw', 'shape', 'icon', 'text', 'mask', 'filter'],
                initMenu: '',
                uiSize: {
                  width: '100%',
                  height: '100%'
                },
                menuBarPosition: 'bottom',
                loadImageFromURL: {
                  path: this.state.editImageSrc,
                  name: 'a'
                },
              }}

              cssMaxHeight={500}
              cssMaxWidth={700}
              selectionStyle={{
                cornerSize: 20,
                rotatingPointOffset: 70
              }}
              usageStatistics={true}
            />
          </div>
        </ModalComponent>

        {/* Adriano solicitou que quando o paciente não tiver atendimento abrir modal para deixar em evidencia */}
        <ModalComponent
          openModal={this.state.iniAtendModal}
          closeModal={() => this.setState({ iniAtendModal: false })}
          modalSecundario={true}
          auto
        >
          <div className="row m-0  p-0">
            <div className="gb-col col-12 ">
              <button className="btn gb-button pl-4 pr-4 mb-1"
                onClick={() => {
                  this.iniciarAtendimento();
                  this.setState({ iniAtendModal: false })
                }}>
                <i className='fa fa-edit'></i> Iniciar Atendimento</button>
              <div><span><i className="fa fa-exclamation-circle"></i> Você precisa iniciar um atendimento para ter interação na ficha deste paciente.</span></div>
            </div>
          </div>
        </ModalComponent>


        <Viewer
          visible={this.state.showImg}
          onClose={() => { this.setState({ showImg: !this.state.showImg }) }}
          images={this.state.images}
          activeIndex={this.state.showImgIndex}
          onChange={(activeImage, index) => { }}
        />



        <div className="gb-cont-page">
          <div className="gb-hist-header">
            {this.props.closeModal &&
              <div className="btClose"
                onClick={() =>
                  this.props.closeModal ? this.props.closeModal() : null
                }
              >
                <i className="fa fa-times"></i>
                <div className="sp">Fechar</div>
              </div>
            }


            {this.state.paciente ? (
              <DadosPaciente
                visible={this.state.visible}
                paciente={this.state.paciente}
                setVisible={(visible) => { this.setState({ visible }) }}
                abandonarPaciente={() => { this.abandonarPaciente() }}
                responsavel={this.state.responsavel}
                proprioResponsavel={this.state.proprioResponsavel} />
            ) : null}
          </div>

          <div className="gb-medico-atendimento  p-0">
            {this.state.buscandoAtendimento ?
              (<div>
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>) :
              !this.state.interacao ? (
                this.state.usuario &&
                [PermissaoGeral.Administrador, PermissaoGeral.Médico].includes(this.state.usuario.permissao) &&
                <div className="row m-0  p-0">
                  <div className="gb-col col-12 col-md-4 text-left">
                    <button className="btn gb-button pl-4 pr-4 mb-1" onClick={() => { this.iniciarAtendimento() }}><i className='fa fa-edit'></i> Iniciar Atendimento</button>
                    <div><span><i className="fa fa-exclamation-circle"></i> Você precisa iniciar um atendimento para ter interação na ficha deste paciente.</span></div>
                  </div>

                </div>
              ) :
                (
                  <div className="row  m-0 p-0">
                    <div className="gb-col col-12 col-md-3  text-left" style={{ alignItems: 'flex-start' }}>
                      <div><i className="fa fa-notes-medical"></i> Atendimento inciado em {moment(this.state.atendimentoObj.data).format('DD/MM/YYYY HH:mm:ss')}</div>
                      <button className="btn gb-button pl-4 pr-4 mb-1" onClick={() => { this.finalizarAtendimento() }}><i className='fa fa-check'></i> Finalizar Atendimento</button>
                    </div>

                    {/* 
                    <div className="gb-col col-12 col-md-3">
                      <div><i className="fa fa-notes-medical"></i>
                        {this.state.CID ? (<>
                          {this.state.CID.label}
                        </>) : (<div>
                          Sem CID informado para o atendimento ainda
                        </div>)}
                      </div>
                      <button className="btn gb-button pl-4 pr-4 mb-1 bg-info" onClick={() => { this.setState({ openModalCID: true }) }}><i className='fa fa-info'></i> Informar CID</button>
                    </div> */}

                    {this.state.paciente && !this.props.viaChat &&
                      <div className="gb-col col-12 col-md-3">
                        <button className="btn gb-button pl-4 pr-4 mb-1"
                          onClick={() => { this.iniciarConversa() }}><i
                            className='fa fa-comment'></i>Iniciar conversa</button>
                      </div>
                    }

                    <div style={{ paddingTop: '13px', alignItems: 'self-end' }} className="gb-col col-12 col-md-3">
                      {this.getAction()}
                    </div>
                  </div>
                )}
            {/* <div >
                {/* <button className="gb-btn-menu"><i className="fa fa-bars"></i></button> *}
                
              </div> */}
          </div>

          <div className="gb-page gb-hist-cont">
            <div className="gb-cont-btnmenu-hist">
              <GbDropdown
                menuItems={this.state.menu2}
                select={this.state.menu.filter(x => x.card == this.state.card)[0].descricao}
                changeTab={this.selectMenu}
                placeholder="Menu"
                style={{ zIndex: 90 }}
              />
            </div>
            {this.state.notifition && this.state.msg != '' ? (
              <Notificacao
                msg={this.state.msg}
                nameclass={this.state.nameclass}
              />
            ) : null}

            {this.state.carregando ? (
              <div className="card" style={{ width: "100%", height: "100%", opacity: 0.8, margin: "0 auto", position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 99 }}>
                <div className="card-body">
                  <div className="text-center" style={{
                    textAlign: 'center', top: '50%',
                    position: 'absolute',
                    left: '50%'
                  }}><center>
                      <PreLoaderWidget ></PreLoaderWidget>
                      carregando...
                    </center>
                  </div>
                </div>
              </div>
            ) : null}

            {this.state.paciente ? (
              <div className="gb-hist-print" id="react-no-print">

                <div className="gb-hist-container">
                  <div className="gb-hist-menu" style={{ top: this.state.top }}>
                    <div className="card" ref={this.divMenu} >
                      <div className="card-body" style={{ padding: '0px' }}>


                        <div className="row">
                          <div className="col-lg-12 col-sm-12">
                            <div className="card-button">
                              <div className="gb-card-button-title">
                                Dados Principais
                              </div>

                              {this.state.menu.map(m => (
                                <div
                                  key={m.card}
                                  className={this.state.card === m.card ? 'card-button-selected' : ''}
                                  onClick={event => this.renderCard(event, m.card)}>
                                  {m.descricao}
                                </div>
                              ))}

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="gb-hist-body" ref={this.divConteudo}>

                    {this.state.card === "historico" ? <ContAnamnese
                      interacao={this.state.interacao}
                      historico={this.state.historico}
                      usuario={this.state.usuario}
                      idPaciente={this.state.idPaciente}
                      aba={this.state.aba}
                      paciente={this.state.paciente}
                      loadingHist={this.state.loadingHist}
                      carregando={this.state.carregando}
                      block={this.state.block}
                      txtComent={this.state.txtComent}
                      idComent={this.state.idComent}
                      _setResponder={this._setResponder}
                      _setComentario={this._setComentario}
                      _clearIdComent={this._clearIdComent} /> : null}


                    {this.state.card === "receita" ? <ContReceita interacao={this.state.interacao}
                      receita={this.state.receita}
                      paciente={this.state.paciente}
                      preloadReceita={this.state.preloadReceita}
                      carregar={this.carregar}
                      usuario={this.state.usuario} /> : null}


                    {this.state.card === "receituario" ? <ContReceituario interacao={this.state.interacao}
                      receituario={this.state.receituario}
                      paciente={this.state.paciente}
                      preloadReceituario={this.state.preloadReceituario}
                      usuario={this.state.usuario} /> : null}

                    {this.state.card === "atestado" ? <ContAtestado interacao={this.state.interacao}
                      atestado={this.state.atestado}
                      paciente={this.state.paciente}
                      usuario={this.state.usuario} /> : null}


                    {this.state.card === "cirurgia" ? <ContCirurgia interacao={this.state.interacao}
                      cirurgia={this.state.cirurgia}
                      paciente={this.state.paciente}
                      usuario={this.state.usuario}
                      preloadCirurgia={this.state.preloadCirurgia}
                      carregar={this.carregar}
                      contexto={this} /> : null}

                    {this.state.card === "exames" ? <ContExames interacao={this.state.interacao}
                      solicitacaoExames={this.state.solicitacaoExames}
                      paciente={this.state.paciente}
                      usuario={this.state.usuario}
                      preloadSolicExame={this.state.preloadSolicExame}
                      profissionais={this.state.profissionais} /> : null}


                    {this.state.card === "anexos" ? <ContAnexo anexos={this.state.anexos}
                      preloadAnexos={this.state.preloadAnexos}
                      openImageAnexo={this.openImageAnexo}
                      editImageAnexo={this.editImageAnexo} /> : null}

                    {
                      this.state.card === "auditoria" ?
                        <ContAuditoria
                          auditorias={this.state.auditorias}
                          preloadAuditoria={this.state.preloadAuditoria}
                          getAuditoriasData={this.getAuditoriasData}
                          openMDLCAD={() => { this.setState({ openMDLCAD: true, modalOBJ: 'auditoria' }) }}
                        /> : null
                    }

                    {this.state.card === "mensagens" ? <ContMensagem paciente={this.state.paciente}
                      usuario={this.state.usuario}
                      preloadMensagens={this.state.preloadMensagens}
                      mensagens={this.state.mensagens}
                      sendMessage={this.sendMessage}
                      wpp={this.state.wpp} /> : null}

                  </div>
                </div>
                {this.state.confirmaResponsavel ? (
                  <div className="alertaPaciente" style={{
                    zIndex: this.state.visible ? 0 : 10
                  }}>
                    <h3>Paciente sem médico responsável!</h3>
                    <h4>Deseja se tornar responsável por este paciente?</h4>
                    <button className="btn btn-warning" type="button" onClick={() => { this.setState({ confirmaResponsavel: false }) }}>
                      <i className='fa fa-eye'></i> Apenas Visualizar
                    </button>
                    <br />
                    <button className="btn btn-primary" type="button" onClick={() => { this.tornarResponsavel() }}>
                      <i className='fa fa-check'></i> Sim. Tornar-me responsável!
                    </button>
                    <br />
                    <h6>Ao se tornar responsável pelo paciente,
                      toda atualização e/ou modificação em seu histórico será direcionado diretamente para você!
                      <br />
                      Tornando-o responsável de acompanhar seu tratamento até estar <b>FINALIZADO</b>
                    </h6>
                  </div>
                ) : null}
              </div>
            ) : null}


            <ModalComponent
              openModal={this.state.openModal}
              closeModal={() => this.setState({ openModal: false })}
              style={{ zIndex: 99999 }}
              modalSecundario={true}

            >
              <Exame
                item={this.state.itemExame}
                usuario={this.state.usuario}
                idPaciente={this.state.idPaciente}
              />
            </ModalComponent>
            {/* <ModalComponent
              style={{ zIndex: 99999 }}

              openModal={this.state.openModalHistorico}
              closeModal={() => this.setState({ openModalHistorico: false })}
            >
              <Historico
                item={this.state.itemHistorico}
                usuario={this.state.usuario}
                idPaciente={this.state.idPaciente}
                aba={this.state.aba}
              />
            </ModalComponent> */}
            {/* <ModalComponent
              style={{ zIndex: 99999 }}

              openModal={this.state.openModalAtestado}
              closeModal={() => this.setState({ openModalAtestado: false })}
            >
              <Atestado
                item={this.state.itemAtestado}
                usuario={this.state.usuario}
                idPaciente={this.state.idPaciente}
                dataAtendimento={this.state.dataAtendimento}
              />
            </ModalComponent> */}
            {/* <ModalComponent
              style={{ zIndex: 99999 }}

              openModal={this.state.openModalCirurgia}
              closeModal={() => {
                this.carregar();


                this.setState({
                  openModalCirurgia: false
                })
              }}
            >
              <Cirurgia
                item={this.state.itemCirurgia}
                usuario={this.state.usuario}
                idPaciente={this.state.idPaciente}
                dataAtendimento={this.state.dataAtendimento}
              />
            </ModalComponent> */}
            <ModalComponent
              style={{ zIndex: 99999 }}
              modalSecundario={true}

              openModal={this.state.openModalRiscoCirurgico}
              closeModal={() => {
                this.carregar();
                this.setState({ openModalRiscoCirurgico: false })
              }
              }
            >
              <RiscoCirurgico
                item={this.state.itemRiscoCirurgico}
                usuario={this.state.usuario}
                idPaciente={this.state.idPaciente}
                dataAtendimento={this.state.dataAtendimento}
              />
            </ModalComponent>
            <ModalComponent
              style={{ zIndex: 99999 }}
              modalSecundario={true}

              openModal={this.state.openModalRetorno}
              closeModal={() => { this.carregar(); this.setState({ openModalRetorno: false }) }}
            >
              <h2>Deseja cadastrar retorno?</h2>
              <Input
                label="Data de Retorno*:"
                placeholder="Data de Retorno"
                type="date"
                id="dataRetorno"
                value={this.state.dataRetorno}
                onChange={text => this.setState({ dataRetorno: text })}
                icone="fa fa-calendar"
              />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <button
                  onClick={() => this._cadastrarRetorno()}
                  type="button"
                  className="btn waves-effect waves-light btn-success"
                >
                  Cadastrar
                </button>
                <button
                  onClick={() => this.setState({ openModalRetorno: false })}
                  type="button"
                  className="btn waves-effect waves-light btn-danger"
                >
                  Cancelar
                </button>
              </div>
            </ModalComponent>
            {/* <ModalComponent
              style={{ zIndex: 99999 }}

              openModal={this.state.openModalReceita}
              closeModal={() => { this.setState({ openModalReceita: false }); this.carregar(); }}
            >
              <Receita
                item={this.state.itemReceita}
                usuario={this.state.usuario}
                idPaciente={this.state.idPaciente}
                paciente={this.state.testeprofissional}
              />
            </ModalComponent> */}
            <ModalComponent
              modalSecundario={true}
              openModal={this.state.openModalCID}
              closeSize={true}
              closeModal={() => {
                console.log("fechou modal");
                this.setState({ openModalCID: false })
              }}>

              <h4>Informe o CID do atendimento </h4>
              <DropDownDoenca sz="1"
                placeholder="Selecione uma doença"
                change={v => { this.setState({ CID2: v }); console.log("CID2", v) }}
                value={this.state.CID2 ? this.state.CID2.value : null}
              />
              <hr />

              <div style={{ float: "right" }}>
                <button
                  style={{ float: "left" }}
                  onClick={() => this._setCIDAtendimento()}
                  type="button"
                  className="btn waves-effect waves-light btn-success"
                >
                  <i className='fa fa-check'></i> Alterar
                </button>
                <button
                  style={{ float: "left" }}
                  onClick={() => this.setState({ openModalCID: false })}
                  type="button"
                  className="btn waves-effect waves-light btn-danger"
                >
                  <i className='fa fa-times'></i>   Cancelar
                </button>
              </div>
            </ModalComponent>
            <ModalComponent
              modalSecundario={true}

              openModal={this.state.openAlteraStatusModal}
              closeModal={() => this.setState({ openAlteraStatusModal: false })}
            >
              {/* esse cara serve para o toast ficar em cima de tudo */}
              <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                pauseOnHover
              />

              <h2>Deseja atualizar o status do histórico?</h2>
              <p>
                Apenas alterando o status que os outros profissionais saberão do
                seu comentário!
              </p>
              <div className="row">
                <div className="col-12">
                  <hr />

                  <h4>Informe o CID </h4>
                  <DropDownDoenca sz="1"
                    placeholder="Selecione uma doença"
                    change={v => { this.setState({ CID: v }); console.log("CID", v) }}
                    value={this.state.CID2 ? this.state.CID2.value : null}
                  />
                  <hr />
                </div>
              </div>
              <ListStatus
                status={this.state.status}
                change={ev => this.setState({ status: ev.target.value })}
              // change={event => this._setStatus(event.target.value)}
              />
              {this.state.status === "Acompanhamento Ambulatorial" ||
                this.state.status === "Acompanhamento Pós Operatório" ? (
                <Input
                  label="Data de Retorno*:"
                  placeholder="Data de Retorno"
                  type="date"
                  id="dataRetorno"
                  value={this.state.dataRetorno}
                  onChange={text => this.setState({ dataRetorno: text })}
                  icone="fa fa-calendar"
                />
              ) : null}

              <div style={{ float: "right" }}>
                <button
                  style={{ float: "left" }}
                  onClick={() => this._setStatus2(this.state.status)}
                  type="button"
                  className="btn waves-effect waves-light btn-success"
                >
                  <i className='fa fa-check'></i> Alterar Status
                </button>
                <button
                  style={{ float: "left" }}
                  onClick={() => this.setState({ openAlteraStatusModal: false })}
                  type="button"
                  className="btn waves-effect waves-light btn-danger"
                >
                  <i className='fa fa-times'></i>   Cancelar
                </button>
              </div>
            </ModalComponent>
            {/* <ModalComponent
              style={{ zIndex: 9999999999999 }}

              openModal={this.state.openModalReceituario}
              closeModal={() => this.setState({ openModalReceituario: false })}
            >
              <Receituario
                item={this.state.itemReceitauario}
                usuario={this.state.usuario}
                idPaciente={this.state.idPaciente}
                paciente={this.state.testeprofissional}
              />
            </ModalComponent> */}

          </div>
        </div>
      </div >
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    initCall: async (paciente) => {
      dispatch(setInitCall(paciente))
      await sleep(200)
      dispatch(setInitCall(null))
    }
  }
};

export default connect(null, mapDispatchToProps)(Paciente);
